import React from 'react';

export default function ResourceBestOf2026Icon({ width = 22, height = 22 }) {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 22 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      role="img"
      aria-label="Best of 2026"
    >
      <circle cx="11" cy="11" r="11" fill="#FF5A46" />
      <circle cx="11" cy="11" r="9.5" stroke="white" strokeWidth="0.6" />
      <g
        fill="none"
        stroke="white"
        strokeWidth="0.4"
        fontFamily="Arial, sans-serif"
        fontSize="9.5"
        textAnchor="middle"
      >
        <text x="11" y="10">
          20
        </text>
        <text x="11" y="18">
          26
        </text>
      </g>
    </svg>
  );
}
